module.exports = __webpack_public_path__ + "img/Indian Oil Corporation Madurai.058bb9ea.jpg";